
import PropTypes from "prop-types";
import * as React from "react";
import debounce from "lodash/debounce";

import settings from "settings";

class AccountInfoSyncManager extends React.Component {

  static propTypes = {
    isFetching: PropTypes.bool.isRequired,

    syncAccountInfo: PropTypes.func.isRequired,
    waitForClanCreation: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.syncAccountInfoDebounce = debounce(this.syncAccountInfo.bind(this), settings.ajaxTools.accountInfoSyncTimeout);
  }

  componentDidMount() {
    this.props.waitForClanCreation();
    this.syncAccountInfoDebounce();
  }

  syncAccountInfo() {
    if (this.props.isFetching) {
      this.syncAccountInfoDebounce();
    } else {
      this.props.syncAccountInfo().then(this.syncAccountInfoDebounce).catch(this.syncAccountInfoDebounce);
    }
  }

  render() {
    return null;
  }
}

export default AccountInfoSyncManager;